
<div class="landing-page" id="home" *ngIf="showPage">
    <header>
        <div class="container">
            <ui-logo [defaultLogo]="valuesService.centralLogos.app" [iconLogo]="isMobile" class="hp-logo brand"></ui-logo>

            <nav class="ml-auto d-flex align-items-center">
                <button id="btn_1578485395" ui-button size="inherit" (click)="goToLoginPage()" *ngIf="!isMobile">{{'login.signin.btn' | translate}}</button>
                <button id="btn_1578485454" ui-button size="inherit" (click)="goToCreateAccount()" *ngIf="!isMobile">{{'home.create.account' | translate}}</button>
                <button id="btn_1578485453" ui-button size="inherit" (click)="goToSupport()">{{'onboarding.support.step1.title' | translate}}</button>
                <button id="changeLanguages" ui-button size="inherit" (click)="openLanguageModal()"
                    [iconLeft]="{type: 'feature', value: 'online', size: isMobile ? 14 : 17}">
                    {{valuesService.languages[lang].code}}
                </button>
            </nav>
        </div>

    </header>


    <main id="main-scrollable">

        <ui-alert id="ui-alert_1652709229" type="warning" class="p-1 bg-warning-15" *ngIf="configService.deployTypeIsBeta() || usefulService.isAlphaInstance()">
            <div class="container px-1" *ngIf="usefulService.isAlphaInstance()">
                {{'global.alpha.version.warning' | translate: {manufacturerName: productsConfigService.getManufacturerName(), siteName: configService.config.siteName} }}
            </div>
            <div class="container px-1" *ngIf="!usefulService.isAlphaInstance() && configService.deployTypeIsBeta()">
                {{'global.beta.version.warning' | translate: {manufacturerName: productsConfigService.getManufacturerName(), siteName: configService.config.siteName} }}

            </div>
        </ui-alert>

        <div class="jumbotron">
            <div class="container h-100 flex-column">

                <div class="content my-auto">
                    <h1 class="color-inherit">{{'hp.title' | translate: {manufacturerName: productsConfigService.getManufacturerName()} }}</h1>
                    <p class="subtitle">{{'hp.subtitle' | translate: {manufacturerName: productsConfigService.getManufacturerName(), siteName: configService.config.siteName} }}</p>

                    <div class="row sm-gutters">
                        <div class="col-12 col-lg-6 col-xl-4 my-1">
                            <button ui-button (click)="goToLoginPage()" model="solid" color="light" class="w-100 color-primary">{{'login.signin.btn' | translate}}</button>
                        </div>
                        <div class="col-12 col-lg-6 col-xl-4 my-1">
                            <button ui-button (click)="goToCreateAccount()" model="outline" color="inherit" class="w-100">{{'home.create.account' | translate}}</button>
                        </div>
                    </div>
                </div>

                <p class="content">
                    <span [innerHTML]="'hp.extra.first' | translate: {manufacturerName: productsConfigService.getManufacturerName()}"></span><br />
                    {{'hp.extra.second' | translate}}
                </p>
            </div>

            <div class="image d-none d-md-initial"></div>
        </div>

        <div class="section" *ngIf="configService.getHomeSectionCapabilities()">
            <div class="container">
                <h2 class="text-center" id="services">{{'hp.platform.capabilities' | translate: {manufacturerName: productsConfigService.getManufacturerName()} }}</h2>

                <div class="row align-items-center justify-content-center mt-3">
                    <div class="col-12 col-sm-10 col-xl-4 text-center">
                        <img width="417" height="288" class="responsive"
                            [src]="valuesService.centralImages.hpDevicesMockup.link"
                            [alt]="valuesService.centralImages.hpDevicesMockup.alt">
                    </div>
                    <div class="col-12 col-xl-8 columned-list mt-4">
                        <ng-container *ngFor="let service of manufacturerServices">
                            <div class="column-item d-flex" *ngIf="service.show()">
                                <ui-icon [type]="service.iconType" [icon]="service.icon" color="primary" shape="icon" size="32" class="mr-2"></ui-icon>
                                <div class="mb-2">
                                    <h4>{{service.title | translate}}</h4>
                                    <p class="my-1 color-shade-60">{{service.descr | translate: {manufacturerName: productsConfigService.getManufacturerName()} }}</p>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="section topProducts" *ngIf="configService.getHomeSectionProducts()">
            <div class="container text-center">
                <h2>{{'hp.products.title' | translate}}</h2>
                <p class="h5 mt-1 color-shade-60">{{'hp.products.subtitle' | translate}}</p>

                <div class="row">
                    <div *ngFor="let product of topProducts; index as i" class="col-12 col-md-4 mt-3">
                        <ui-card type="raised" class="h-100 product" id="card_1578485392_{{i}}" [clickable]="true" (click)="product.cta()">
                            <card-body class="py-3 px-2">
                                <span class="color-shade-40">{{product.subtitle | translate}}</span>
                                <h4>{{product.name}}</h4>
                                <p class="b1 my-2 mx-auto">{{product.descr | translate}}</p>
                                <img [src]="product.ill.link" alt="" height="82">
                            </card-body>
                            <card-footer class="p-0">
                                <button ui-button size="xl" model="solid" color="primary" class="w-100" id= btn_1578485392_{{i}}>{{'hp.product.cta.more' | translate}}</button>
                            </card-footer>
                        </ui-card>
                    </div>
                </div>

                <ui-card type="raised" class="mt-4 text-left bg-primary-5">
                    <card-body class="p-0">
                        <div class="row no-gutters">
                            <div *ngFor="let service of topServices; index as i" class="col-12 col-md-4">
                                <div class="d-flex align-items-center p-2 service">
                                    <ui-icon type="app" [icon]="service.icon"
                                        bg="brand" color="light" shape="squircle" size="42" iconSize="85%">
                                    </ui-icon>
                                    <div class="ml-2">
                                        <h5 class="mt-1">{{service.name}}</h5>
                                        <p class="b1 mb-half-spas mt-half-spas">{{service.descr | translate}}</p>
                                        <button ui-button model="link" color="primary"id= btn_1578485391_{{i}} (click)="service.cta()" [iconRight]="{ type:'general', value:'forward'}">
                                            {{'hp.product.cta.details' | translate}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card-body>
                </ui-card>
            </div>
        </div>

        <div class="container" *ngIf="configService.getHomeSectionAppBanner()">
            <ui-card type="raised" class="mt-4">
                <card-header class="only-child flex-nowrap align-items-start p-2">
                    <img [src]="valuesService.centralImages.appIcon.link" [alt]="valuesService.centralImages.appIcon.alt" width="60" height="60">
                    <div class="row no-gutters align-items-center ml-2">
                        <div class="col-12 col-md">
                            <h5>{{'hp.app.banner.title' | translate: {manufacturerName: productsConfigService.getManufacturerName(), siteName: configService.config.siteName} }}</h5>
                            <p class="my-1 color-shade-60">{{'home.available.platforms' | translate}}</p>
                        </div>

                        <div class="row sm-gutters my-1">
                            <a class="app-btn col-6" (click)="usefulService.goToAppStore($event)" [href]="valuesService.appStoreLink">
                                <img [src]="valuesService.centralImages.appStoreSvg.link" [alt]="valuesService.centralImages.appStoreSvg.alt" class="d-block w-100">
                            </a>
                            <a class="app-btn col-6" (click)="goToGooglePlay($event)" [href]="linksService.googlePlayLink">
                                <img [src]="valuesService.centralImages.googlePlaySvg.link" [alt]="valuesService.centralImages.googlePlaySvg.alt" class="d-block w-100">
                            </a>
                        </div>
                    </div>
                </card-header>
            </ui-card>
        </div>

        <footer class="b3 py-3 text-center">
            <div class="links b3 my-1">
                <a ui-button model="link" size="inherit" [href]="links.legal" target="_blank">{{'hp.footer.link.legal' | translate}}</a>
                <a ui-button model="link" size="inherit" [href]="links.privacy" target="_blank">{{'hp.footer.link.privacy' | translate}}</a>
                <a ui-button model="link" size="inherit" [href]="links.support" target="_blank">{{'hp.footer.link.support' | translate}}</a>
            </div>

            <span class="copyright">&#169; {{year}} {{productsConfigService.getManufacturerName()}} <span id="span_1637850722" class="color-shade-70">3.21.1247.5</span></span>

            <p *ngIf="configService.config.poweredBy" class="powered-by-Bitdefender"></p>
        </footer>

    </main>

</div>
